//@flow
import {
    bulkSchedulingConfigFetchApi,
    validateEntityIds as validateEntityIdsApi
} from 'common/middleware/api';
import PaginatedEntityActions from 'common/redux/actions/PaginatedEntityActions';

import type { MasterSchedulingConfig } from 'common/models/internal/MasterSchedulingConfig';

type Params = {
    clientId: string,
    schedulingConfigId?: string
};

class SchedulingConfigActions extends PaginatedEntityActions<
    MasterSchedulingConfig,
    Params
> {}

export default new SchedulingConfigActions(
    'SchedulingConfig',
    null,
    bulkSchedulingConfigFetchApi,
    null,
    null,
    validateEntityIdsApi
);
